<template>
  <div>
    <flex-align
      v-if="
        isGridBuilder &&
        ['GridItemWrapper', 'CContainerItem'].includes(
          selected.parent().name,
        ) &&
        !hideFlexAlignment
      "
      :mode="mode"
      :disable-alignment="hideFlexAlignment"
      :disable-constrain="hideFlexAlignment"
    ></flex-align>
    <cvt-collapse
      :accordion="true"
      :theme="mode === 'LIGHT' ? 'light' : 'dark'"
      :prepend-chevron="prependChevron"
    >
      <cvt-collapse-item
        v-if="containerItemSettings.isWrappedByCContainerItem"
        title="Container Item Options"
        :special-style="isSpecialStyle"
      >
        <c-container-item-options :mode="mode" />
      </cvt-collapse-item>
      <cvt-collapse-item
        :title="$t('elements.properties.settings')"
        name="settings"
        :initial-active="true"
        :special-style="isSpecialStyle"
      >
        <div class="row">
          <div class="col">
            <icon-manager></icon-manager>
          </div>
        </div>
        <div v-if="OrgName !== orgNameFreshWork" class="divider"></div>
        <br v-if="OrgName === orgNameFreshWork" />
        <div class="row">
          <div class="col">
            <h6 :class="textColorClass" class="m-0">Resize</h6>
          </div>
          <div class="col-12">
            <resize
              size-key="size"
              :min="1"
              :step="1"
              :max="20"
              :hide-label="true"
            ></resize>
          </div>
        </div>
        <div v-if="OrgName !== orgNameFreshWork" class="divider"></div>
        <br v-if="OrgName === orgNameFreshWork" />

        <flex-align v-if="!isGridBuilder" :mode="mode"></flex-align>

        <div v-if="OrgName !== orgNameFreshWork" class="divider"></div>
        <br v-if="OrgName === orgNameFreshWork" />

        <div class="row">
          <div v-if="isGridBuilder" class="col-12">
            Background
            <colors :to-bg="true" :mode="mode"></colors>
          </div>
          <div class="col-12">
            Foreground
            <colors :mode="mode"></colors>
          </div>
        </div>

        <div v-if="isGridBuilder" class="divider mt-2" />
        <border-style-options
          v-if="
            isGridBuilder &&
            ['GridItemWrapper', 'CContainerItem'].includes(
              selected.parent().name,
            )
          "
          :mode="mode"
          :border-style="selected.parent().borderStyle || 'none'"
          :border-color="selected.parent().borderColor || null"
          :border-width="selected.parent().borderWidth || 0"
          :border-radius="selected.parent().borderRadius || 0"
          :border-position="selected.parent().borderPosition || {}"
          :show-border-position="true"
          :update-prop-function="selected.parent().updateProp"
        />
        <element-anchor disable-alt-text></element-anchor>
      </cvt-collapse-item>

      <cvt-collapse-item
        :title="$t('elements.properties.spacing.label')"
        name="spacing"
        :special-style="isSpecialStyle"
      >
        <spacing-ctrl></spacing-ctrl>
      </cvt-collapse-item>
    </cvt-collapse>
  </div>
</template>

<script>
import * as _ from 'lodash'
import Resize from './Resize.vue'
import SpacingCtrl from './SpacingCtrl.vue'
import FlexAlign from './FlexAlign.vue'
import Colors from '../theme/Colors.vue'
import IconManager from './IconManager.vue'
import ElementAnchor from './ElementAnchor.vue'
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex'
import * as getters from '../../../store/modules/getters'
import * as actions from '../../../store/modules/actions'
import * as mutations from '../../../store/modules/mutations'
import {
  LEFT_SIDEBAR_FRESHWORKS,
  LEFT_SIDEBAR_STANDARD,
} from '../../../../../../storybook/components/constants'
import CContainerItemOptions, {
  useShowContainerItem,
} from './CContainerOptions/CContainerItemOptions.vue'
import BorderStyleOptions from './BorderStyleOptions.vue'
export default {
  components: {
    Resize,
    SpacingCtrl,
    FlexAlign,
    Colors,
    IconManager,
    ElementAnchor,
    CContainerItemOptions,
    BorderStyleOptions,
  },
  props: {
    mode: {
      type: String,
      default: 'LIGHT',
    },
    prependChevron: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeTab: 'settings',
      orgNameFreshWork: LEFT_SIDEBAR_FRESHWORKS,
    }
  },
  computed: {
    ...mapGetters({
      selected: getters.SELECTOR_SELECTED,
      config: getters.AUTH_GET_USER_CONFIG,
      isGridBuilder: getters.IS_GRID_BUILDER,
    }),
    ...mapState('globalTheme', {
      OrgName: ({ globalTheme }) =>
        globalTheme.OrgName !== undefined
          ? globalTheme.OrgName
          : LEFT_SIDEBAR_STANDARD,
    }),
    textColorClass() {
      return { 'text-white': this.mode == 'DARK' }
    },
    isSpecialStyle() {
      return this.OrgName === LEFT_SIDEBAR_FRESHWORKS
    },
    hideFlexAlignment() {
      return this.config.HIDE_FLEX_ALIGNMENT_OPTIONS?.icon === true
    },
    containerItemSettings() {
      return useShowContainerItem(this.selected)
    },
  },
  created() {
    this.radius = this.selected.radius
  },
  methods: {
    ...mapActions({
      updateProp: actions.SELECTOR_UPDATE_PROP,
    }),
  },
}
</script>

<style lang="scss"></style>
